import { render } from "./Reportes.vue?vue&type=template&id=470240b3&scoped=true"
import script from "./Reportes.vue?vue&type=script&lang=js"
export * from "./Reportes.vue?vue&type=script&lang=js"

import "./Reportes.vue?vue&type=style&index=0&id=470240b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470240b3"]])

export default __exports__